import createStyles from '@material-ui/styles/createStyles'
import { Theme } from 'Theme'
import { colors } from 'Theme';

export default ({ spacing, palette }: typeof Theme) => createStyles({
    paperTitreNotifications : {
        width : '100%',
        backgroundColor : colors.grey.main,
        color : 'white',
        fontSize : 18,
        display : 'flex',
        alignItems : 'center',
        justifyContent : 'center',
        height : 44,
        borderRadius : 4
    },
    paperNotifications : {
        width: '100%',
    },
    buttonClear : {
        width : 44,
        minWidth : 44,
        height : 44,
        marginLeft : spacing(1),
    },
    notificationTitle : {
        color : colors.grey.dark,
        fontWeight : 700,
        fontSize : 12
    },
    notificationMessage : {
        fontSize : 12,
        color : palette.primary.main
    },
    notificationDate : {
        fontSize : 10,
        color : palette.primary.main
    },
    notificationClose : {
        width : 12,
        height : 12,
        color : colors.grey.main,
        cursor : 'pointer',
    }
});